var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHorizontalPoints = function SvgHorizontalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.417 11a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0ZM11 12.833a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666Zm6.417 0a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666Z"
  })));
};

export default SvgHorizontalPoints;